import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';
import {TState} from '../../../../redux/store.type';
import NewEventForm from '../../components/newEventForm/NewEventForm';
import {newEventInitialValues, newEventSteps, newEventValidationSchema} from '../../globalSteps';

function CreateSubscriptionEvent() {
    const event = useSelector((s:TState) => s.event);
    const {t} = useTranslation(['global', 'newEvent', 'errors', 'layout']);
    const {isOpenLocaleStep} = useSelector((s:TState) => s.ui.event);

    // Define steps for subscription
    const subscriptionSteps = {
        title: {
            ...newEventSteps.title,
            navigationName: 'subscriptionTitle',
            texts: {
                header: '',
                description: '',
                topAfterFill: 'subscriptionTitleTopAfterFill'
            },
            compProps: {
                text: 'subscriptionTitleText',
                description: 'subscriptionTitleDesc'
            }
        },
        date: {
            ...newEventSteps.simpleDate,
            imageName: 'subscriptionDate',
            texts: {
                header: 'subscriptionDateHeader',
                description: 'subscriptionDateDesc',
                topHeader: 'dateTopHeaderSubscription',
                topAfterFill: 'subscriptionDateTopAfterFill'
            },
            compProps: {
                startDateText: 'seasonStart',
                endDateText: 'seasonEnd'
            }
        },
        locale: {
            ...newEventSteps.locale
        },
        location: {
            ...newEventSteps.location,
            imageName: 'subscriptionLocation',
            texts: {
                header: 'subscriptionLocationHeader',
                topAfterFill: 'subscriptionLocationTopAfterFill'
            },
            compProps: {
                addressTextKey: 'subscriptionAddress',
                addressDescKey: 'subscriptionAddressDesc'
            }
        },
        description: {
            ...newEventSteps.description,
            texts: {
                header: 'subscriptionDescriptionHeader',
                description: 'subscriptionDescriptionDesc',
                topHeader: 'subscriptionDescriptionTopHeader',
                topAfterFill: 'subscriptionDescriptionTopAfterFill'
            }
        },
        fullDescription: {
            ...newEventSteps.fullDescription,
            texts: {
                header: 'subscriptionFullDescriptionHeader',
                description: 'subscriptionFullDescriptionDesc',
                topHeader: 'fullDescription',
                topAfterFill: 'subscriptionFullDescriptionTopAfterFill'
            }
        },
        category: {
            ...newEventSteps.category(t),
            texts: {
                header: 'subscriptionCategoryHeader',
                topAfterFill: 'subscriptionCategoryTopAfterFill'
            }
        }
    };

    const {title, description, locale, location, date, fullDescription} = newEventInitialValues(event);

    const initialValues = {
        title,
        description,
        locale,
        location,
        date,
        fullDescription,
        category: event.category || []
    };

    const {title: titleValid, description: descriptionValid, locale: localValid, location: locationValid, fullDescription: fullDescriptionValid} = newEventValidationSchema(t);
    
    const initialValidationSchema = Yup.object().shape({
        title: titleValid,
        description: descriptionValid,
        locale: localValid,
        location: locationValid,
        fullDescription: fullDescriptionValid,
        category: Yup.array().of(Yup.number().required()).min(1).required()
    });

    const steps = [
        subscriptionSteps.title,
        subscriptionSteps.category,
        subscriptionSteps.location,
        subscriptionSteps.date,
        ...(isOpenLocaleStep ? [subscriptionSteps.locale] : []),
        subscriptionSteps.description,
        subscriptionSteps.fullDescription
    ];

    return (
        <NewEventForm
            initialValues={initialValues}
            validationSchema={initialValidationSchema}
            steps={steps}
            headerTextKey="newEventTextSubscription"
        />
    );
}

export default CreateSubscriptionEvent;
